module.exports = __webpack_public_path__ + "img/applicable-scene-1.877a66d.png";